import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrImageViewerComponent } from './pr-image-viewer.component';

@NgModule({
  declarations: [PrImageViewerComponent],
  imports: [CommonModule],
  exports: [PrImageViewerComponent],
})
export class PrImageViewerModule {}
